/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { ActionLogInfo, ActionLogRequestFilter, ActionLogTable } from 'models/api/actionLog';
import ResTable from 'models/api/table';

export const getTypesList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>('/ActionLog/types');
    return data;
};

export const getActionLogExcel = async (axios: AxiosInstance, params: ActionLogRequestFilter) => {
    const { data } = await axios.get<Blob>('/ActionLog/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const getActionLogs = async (axios: AxiosInstance, params: ActionLogRequestFilter) => {
    const { data } = await axios.get<ResTable<ActionLogTable>>('/ActionLog', {
        params,
    });
    return data;
};

export const getActionLog = async (axios: AxiosInstance, id: string | number) => {
    const { data } = await axios.get<ActionLogInfo>(`/ActionLog/${id}`);
    return data;
};
